import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function ScrollZoomControl() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();

    const onWheel = (e: WheelEvent) => {
      if (e.ctrlKey) {
        e.preventDefault();
        map.scrollWheelZoom.enable();
      } else {
        map.scrollWheelZoom.disable();
      }
    };

    container.addEventListener('wheel', onWheel);

    return () => {
      container.removeEventListener('wheel', onWheel);
    };
  }, [map]);

  return null;
}
